import { ChangeEvent, createRef, SetStateAction, useState } from 'react'
import styled from 'styled-components'

import { LIMIT_CHARACTER_PUBLICATION } from 'src/utils/constants'
import i18n from 'src/i18n'
import CustomAlert from '@hotmart/space-lib/dist/components/customAlert'
import { faCircleXmark } from '@fortawesome/pro-light-svg-icons/faCircleXmark'
import { PropsCreatePost } from '../types'

const TitleArea = styled.textarea`
  background: transparent;
  outline: 0;
  resize: none;
  overflow: hidden;
`

TitleArea.displayName = 'TitleArea'

export type InputMarkdownTitleProps = {
  publication: PropsCreatePost
  setPublication: (publication: SetStateAction<PropsCreatePost>) => void
}

const InputMarkdownTitle = ({ publication, setPublication }: InputMarkdownTitleProps) => {
  const [titleError, setTitleError] = useState(false)
  const titleAreaRef = createRef<HTMLTextAreaElement>()

  const handleIsTitleInvalid = (title: string | null) => setTitleError(!title?.length)

  const updateTitleHeight = (element: HTMLTextAreaElement) => {
    const elementHeightWithScroll = '5px'

    element.style.height = elementHeightWithScroll
    element.style.height = `${element.scrollHeight}px`
  }

  const handleTitleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const newTitle = event.target.value.trim() ? event.target.value : ''
    setPublication((prevState) => {
      return { ...prevState, title: newTitle }
    })

    updateTitleHeight(event.currentTarget)
    handleIsTitleInvalid(newTitle)
  }

  const handleBlur = () => {
    handleIsTitleInvalid(publication.title)
  }

  return (
    <div className="_ml-4 _d-flex _flex-column _w-full">
      <div className="_d-flex _align-items-center _w-full">
        <TitleArea
          autoFocus
          rows={1}
          ref={titleAreaRef}
          value={publication.title || ''}
          aria-label={i18n.t('input_publish.title_aria_label')}
          className="_p-0 _border-0 _text-gray-900 _text-3 _w-full"
          placeholder={i18n.t('input_publish.placeholder_title')}
          data-test="title-input"
          data-name="title-input"
          onInput={handleTitleChange}
          onBlur={handleBlur}
          maxLength={LIMIT_CHARACTER_PUBLICATION}
        />
        <span className="_text-gray-500 _text-1 _ml-4" data-test="title-length">
          {`${publication.title ? publication.title.length : 0}/${LIMIT_CHARACTER_PUBLICATION}`}
        </span>
      </div>
      {titleError && (
        <CustomAlert
          className="_mt-1 _mr-8"
          variation="danger"
          icon={faCircleXmark}
          iconClassName="_text-4"
        >
          {i18n.t('input_publish.error.title_required')}
        </CustomAlert>
      )}
    </div>
  )
}

export default InputMarkdownTitle
